import module from 'backoffice/dashboard/module.js'
import template from './template.html'

export class BackofficeDashboardHerramientasComponent {
}

module.component('backofficeDashboardHerramientas', {
  controller: BackofficeDashboardHerramientasComponent,
  template: template,
  bindings: {},
})



// WEBPACK FOOTER //
// ./src/dashboard/components/herramientas/components.js